import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    activeTab: 'dashboard',
    view: null,
    viewPayload: null,
    notifications: [],
    activeModal: null,
    modalPayload: null,
  },
  reducers: {
    navigateTo(state, { payload: { tab, view, viewPayload } }) {
      state.activeTab = tab;
      state.view = view ?? null;
      state.viewPayload = viewPayload ?? null;
    },
    setView(state, { payload: { view, viewPayload } }) {
      state.view = view ?? null;
      state.viewPayload = viewPayload ?? null;
    },
    goBack(state) {
      state.view = null;
      state.viewPayload = null;
    },
    pushNotification(state, { payload }) {
      state.notifications.push({
        id: Date.now().toString(),
        autoDismiss: true,
        ...payload,
      });
    },
    dismissNotification(state, { payload: id }) {
      state.notifications = state.notifications.filter((n) => n.id !== id);
    },
    openModal(state, { payload: { modal, data } }) {
      state.activeModal = modal;
      state.modalPayload = data ?? null;
    },
    closeModal(state) {
      state.activeModal = null;
      state.modalPayload = null;
    },
  },
});

export const {
  navigateTo,
  setView,
  goBack,
  pushNotification,
  dismissNotification,
  openModal,
  closeModal,
} = uiSlice.actions;
export default uiSlice.reducer;
